module.exports = __webpack_public_path__ + "static/media/delete.c91a89fa.svg";